import React from 'react'
import { Link } from "react-router-dom";


const BestProducts = () => {
    return (
        <>

            <div className="our-projects-royal" style={{ marginTop: "-90px" }}>
                <div className="container">
                    <div className="row section-row">
                        <div className="col-lg-12">
                            {/* Section Title Start */}
                            <div className="section-title section-title-center">
                                <span className="section-sub-title wow fadeInUp" style={{ visibility: 'visible', animationName: 'fadeInUp' }}> Best Products</span>
                                <h2 className="text-anime-style-3" data-cursor="-opaque" aria-label="Our projects delivering reliable clean energy solutions" style={{ perspective: 400 }}>
                                    <div className="split-line" aria-hidden="true" style={{ position: 'relative', display: 'block', textAlign: 'center' }}>
                                        <div aria-hidden="true" style={{ position: 'relative', display: 'inline-block' }}>
                                            Best Solutions for Your Home, Office & Industry
                                        </div>
                                    </div>
                                </h2>
                            </div>
                            {/* Section Title End */}
                        </div>
                    </div>
                    <div className="row">



                        <div className="col-xl-4 col-md-6">
                            {/* Project Item Start */}
                            <div className="project-item wow fadeInUp" style={{ visibility: 'visible', animationName: 'fadeInUp' }}>
                                <div className="project-item-image">
                                    <Link to="https://wa.me/919516839231" data-cursor-text="View">
                                        <figure>
                                            <img src="./assets/solar/tata.webp" alt />
                                        </figure>
                                    </Link>
                                </div>
                                <div className="project-item-body">
                                    {/* <div className="project-item-content">
                                        <h2><Link to="https://wa.me/919516839231">Solar Inverter</Link></h2>
                                    </div> */}
                                    <div className="project-item-btn">
                                        <Link to="https://wa.me/919516839231" className="readmore-btn">Shop Now</Link>
                                    </div>
                                </div>
                            </div>
                            {/* Project Item End */}
                        </div>
                        <div className="col-xl-4 col-md-6">
                            {/* Project Item Start */}
                            <div className="project-item wow fadeInUp" data-wow-delay="0.2s" style={{ visibility: 'visible', animationDelay: '0.2s', animationName: 'fadeInUp' }}>
                                <div className="project-item-image">
                                    <Link to="https://wa.me/919516839231" data-cursor-text="View">
                                        <figure>
                                            <img src="./assets/solar/Adani Solar Panel.webp" alt />
                                        </figure>
                                    </Link>
                                </div>
                                <div className="project-item-body">
                                    {/* <div className="project-item-content">
                                        <h2><Link to="https://wa.me/919516839231">All-in-one solar street lights</Link></h2>
                                    </div> */}
                                    <div className="project-item-btn">
                                        <Link to="https://wa.me/919516839231" className="readmore-btn">Shop Now</Link>
                                    </div>
                                </div>
                            </div>
                            {/* Project Item End */}
                        </div>
                       
                        <div className="col-xl-4 col-md-6">
                            {/* Project Item Start */}
                            <div className="project-item wow fadeInUp" style={{ visibility: 'visible', animationName: 'fadeInUp' }}>
                                <div className="project-item-image">
                                    <Link to="https://wa.me/919516839231" data-cursor-text="View">
                                        <figure>
                                            <img src="./assets/solar/Solar Inverter_1.webp" alt />
                                        </figure>
                                    </Link>
                                </div>
                                <div className="project-item-body">
                                    <div className="project-item-content">
                                        <h2><Link to="https://wa.me/919516839231">Solar Inverter</Link></h2>
                                    </div>
                                    <div className="project-item-btn">
                                        <Link to="https://wa.me/919516839231" className="readmore-btn">Shop Now</Link>
                                    </div>
                                </div>
                            </div>
                            {/* Project Item End */}
                        </div>
                        <div className="col-xl-4 col-md-6">
                            {/* Project Item Start */}
                            <div className="project-item wow fadeInUp" data-wow-delay="0.2s" style={{ visibility: 'visible', animationDelay: '0.2s', animationName: 'fadeInUp' }}>
                                <div className="project-item-image">
                                    <Link to="https://wa.me/919516839231" data-cursor-text="View">
                                        <figure>
                                            <img src="./assets/solar/All-in-one solar street lights.webp" alt />
                                        </figure>
                                    </Link>
                                </div>
                                <div className="project-item-body">
                                    <div className="project-item-content">
                                        <h2><Link to="https://wa.me/919516839231">All-in-one solar street lights</Link></h2>
                                    </div>
                                    <div className="project-item-btn">
                                        <Link to="https://wa.me/919516839231" className="readmore-btn">Shop Now</Link>
                                    </div>
                                </div>
                            </div>
                            {/* Project Item End */}
                        </div>
                        <div className="col-xl-4 col-md-6">
                            {/* Project Item Start */}
                            <div className="project-item wow fadeInUp" data-wow-delay="0.4s" style={{ visibility: 'visible', animationDelay: '0.4s', animationName: 'fadeInUp' }}>
                                <div className="project-item-image">
                                    <Link to="https://wa.me/919516839231" data-cursor-text="View">
                                        <figure>
                                            <img src="./assets/solar/hardoll 150W All-in-One Solar Street Light.webp" alt />
                                        </figure>
                                    </Link>
                                </div>
                                <div className="project-item-body">
                                    <div className="project-item-content">
                                        <h2><Link to="https://wa.me/919516839231">Hardoll 150W All-in-One Solar Street Light</Link></h2>
                                    </div>
                                    <div className="project-item-btn">
                                        <Link to="https://wa.me/919516839231" className="readmore-btn">Shop Now</Link>
                                    </div>
                                </div>
                            </div>
                            {/* Project Item End */}
                        </div>

                        <div className="col-xl-4 col-md-6">
                            {/* Project Item Start */}
                            <div className="project-item wow fadeInUp" style={{ visibility: 'visible', animationName: 'fadeInUp' }}>
                                <div className="project-item-image">
                                    <Link to="https://wa.me/919516839231" data-cursor-text="View">
                                        <figure>
                                            <img src="./assets/solar/Solar Structure.webp" alt />
                                        </figure>
                                    </Link>
                                </div>
                                <div className="project-item-body">
                                    <div className="project-item-content">
                                        <h2><Link to="https://wa.me/919516839231">Solar Structure</Link></h2>
                                    </div>
                                    <div className="project-item-btn">
                                        <Link to="https://wa.me/919516839231" className="readmore-btn">Shop Now</Link>
                                    </div>
                                </div>
                            </div>
                            {/* Project Item End */}
                        </div>
                        <div className="col-xl-4 col-md-6">
                            {/* Project Item Start */}
                            <div className="project-item wow fadeInUp" data-wow-delay="0.2s" style={{ visibility: 'visible', animationDelay: '0.2s', animationName: 'fadeInUp' }}>
                                <div className="project-item-image">
                                    <Link to="https://wa.me/919516839231" data-cursor-text="View">
                                        <figure>
                                            <img src="./assets/solar/solar kit.webp" alt />
                                        </figure>
                                    </Link>
                                </div>
                                <div className="project-item-body">
                                    <div className="project-item-content">
                                        <h2><Link to="https://wa.me/919516839231">Solar 5KW to 5.5KW On-Grid Single</Link></h2>
                                    </div>
                                    <div className="project-item-btn">
                                        <Link to="https://wa.me/919516839231" className="readmore-btn">Shop Now</Link>
                                    </div>
                                </div>
                            </div>
                            {/* Project Item End */}
                        </div>
                        <div className="col-xl-4 col-md-6">
                            {/* Project Item Start */}
                            <div className="project-item wow fadeInUp" data-wow-delay="0.4s" style={{ visibility: 'visible', animationDelay: '0.4s', animationName: 'fadeInUp' }}>
                                <div className="project-item-image">
                                    <Link to="https://wa.me/919516839231" data-cursor-text="View">
                                        <figure>
                                            <img src="./assets/solar/Lithium-Battery-1.webp" alt />
                                        </figure>
                                    </Link>
                                </div>
                                <div className="project-item-body">
                                    <div className="project-item-content">
                                        <h2><Link to="https://wa.me/919516839231">Rooftop Solar Solutions</Link></h2>
                                    </div>
                                    <div className="project-item-btn">
                                        <Link to="https://wa.me/919516839231" className="readmore-btn">Shop Now</Link>
                                    </div>
                                </div>
                            </div>
                            {/* Project Item End */}
                        </div>

                        <div className="col-xl-4 col-md-6">
                            {/* Project Item Start */}
                            <div className="project-item wow fadeInUp" style={{ visibility: 'visible', animationName: 'fadeInUp' }}>
                                <div className="project-item-image">
                                    <Link to="https://wa.me/919516839231" data-cursor-text="View">
                                        <figure>
                                            <img src="./assets/solar/Solar Inverter.webp" alt />
                                        </figure>
                                    </Link>
                                </div>
                                <div className="project-item-body">
                                    <div className="project-item-content">
                                        <h2><Link to="https://wa.me/919516839231">Solar Inverter</Link></h2>
                                    </div>
                                    <div className="project-item-btn">
                                        <Link to="https://wa.me/919516839231" className="readmore-btn">Shop Now</Link>
                                    </div>
                                </div>
                            </div>
                            {/* Project Item End */}
                        </div>
                        <div className="col-xl-4 col-md-6">
                            {/* Project Item Start */}
                            <div className="project-item wow fadeInUp" data-wow-delay="0.2s" style={{ visibility: 'visible', animationDelay: '0.2s', animationName: 'fadeInUp' }}>
                                <div className="project-item-image">
                                    <Link to="https://wa.me/919516839231" data-cursor-text="View">
                                        <figure>
                                            <img src="./assets/solar/Lithium Battery.webp" alt />
                                        </figure>
                                    </Link>
                                </div>
                                <div className="project-item-body">
                                    <div className="project-item-content">
                                        <h2><Link to="https://wa.me/919516839231">Lithium Battery</Link></h2>
                                    </div>
                                    <div className="project-item-btn">
                                        <Link to="https://wa.me/919516839231" className="readmore-btn">Shop Now</Link>
                                    </div>
                                </div>
                            </div>
                            {/* Project Item End */}
                        </div>
                        <div className="col-xl-4 col-md-6">
                            {/* Project Item Start */}
                            <div className="project-item wow fadeInUp" data-wow-delay="0.4s" style={{ visibility: 'visible', animationDelay: '0.4s', animationName: 'fadeInUp' }}>
                                <div className="project-item-image">
                                    <Link to="https://wa.me/919516839231" data-cursor-text="View">
                                        <figure>
                                            <img src="./assets/solar/Inverter Battery.webp" alt />
                                        </figure>
                                    </Link>
                                </div>
                                <div className="project-item-body">
                                    <div className="project-item-content">
                                        <h2><Link to="https://wa.me/919516839231">Inverter Battery</Link></h2>
                                    </div>
                                    <div className="project-item-btn">
                                        <Link to="https://wa.me/919516839231" className="readmore-btn">Shop Now</Link>
                                    </div>
                                </div>
                            </div>
                            {/* Project Item End */}
                        </div>

                    </div>
                </div>
            </div>

        </>
    )
}

export default BestProducts
